import { Stack, Typography } from "@mui/material";
import { BiggerThanSmallAndSmallerThanMediumText } from "../../common/styles/Text.styles";
import { iconGap, perelynPrimary, smallGap } from "../../styles/consts";

export default function Explanation({ displayedMatch }) {
  if (!displayedMatch || !displayedMatch.explanation) {
    return null;
  }

  const explanation = displayedMatch.explanation;

  const renderSection = (title: string, content: string | null | undefined) => {
    if (!content || typeof content !== "string" || content.trim() === "")
      return null;

    return (
      <Stack sx={{ marginBottom: iconGap }}>
        <BiggerThanSmallAndSmallerThanMediumText
          sx={{
            marginBottom: "0.25rem",
            paddingLeft: smallGap,
            position: "relative",
          }}
        >
          <span
            style={{
              position: "absolute",
              left: 0,
              color: perelynPrimary,
            }}
          >
            •
          </span>
          {title}
        </BiggerThanSmallAndSmallerThanMediumText>
        <Typography sx={{ paddingLeft: "2rem", position: "relative" }}>
          <span
            style={{
              position: "absolute",
              left: smallGap,
            }}
          >
            -
          </span>
          {content}
        </Typography>
      </Stack>
    );
  };

  const renderBulletPoints = (
    title: string,
    content: string | string[] | null | undefined
  ) => {
    if (!content) return null;

    // Handle both string and array inputs
    let points: string[] = [];

    if (Array.isArray(content)) {
      points = content
        .map((point) => (typeof point === "string" ? point.trim() : ""))
        .filter((point) => point !== "");
    } else if (typeof content === "string" && content.trim() !== "") {
      points = content
        .split(",")
        .map((point) => point.trim())
        .filter((point) => point !== "");
    }

    if (points.length === 0) return null;

    return (
      <Stack sx={{ marginBottom: iconGap }}>
        <BiggerThanSmallAndSmallerThanMediumText
          sx={{
            marginBottom: "0.25rem",
            paddingLeft: smallGap,
            position: "relative",
          }}
        >
          <span
            style={{
              position: "absolute",
              left: 0,
              color: perelynPrimary,
            }}
          >
            •
          </span>
          {title}
        </BiggerThanSmallAndSmallerThanMediumText>
        {points.map((point, index) => (
          <Typography
            key={index}
            sx={{ paddingLeft: "2rem", position: "relative" }}
          >
            <span
              style={{
                position: "absolute",
                left: smallGap,
              }}
            >
              -
            </span>
            {point}
          </Typography>
        ))}
      </Stack>
    );
  };

  return (
    <Stack sx={{ padding: smallGap, paddingTop: 0 }}>
      <BiggerThanSmallAndSmallerThanMediumText sx={{ marginBottom: smallGap }}>
        Explanation
      </BiggerThanSmallAndSmallerThanMediumText>

      {renderSection("Overall Assessment", explanation.overall_assessment)}
      {renderBulletPoints("Development Areas", explanation.development_areas)}
    </Stack>
  );
}
